import React from 'react'
import {Block, Row} from 'jsxstyle'
import {CopilotMessageDto, SenderType} from '../../../services/CopilotMessage/type'
import {formatDate} from '../../../common/utils/dateUtils'
import {motion} from 'framer-motion'

interface MessageBubbleProps {
  message: CopilotMessageDto
  isStreaming?: boolean
  streamingContent?: string
}

const MessageBubble: React.FC<MessageBubbleProps> = ({message, isStreaming = false, streamingContent = ''}) => {
  const isUser = message.senderType === SenderType.HUMAN
  const displayContent = isStreaming ? streamingContent : message.content.text

  const dotVariants = {
    initial: {
      y: 0,
      opacity: 0.6,
    },
    animate: {
      y: [-2, -4, 0],
      opacity: [0.6, 1, 0.6],
      transition: {
        repeat: Infinity,
        duration: 0.6,
        ease: 'easeInOut',
      },
    },
  }

  return (
    <Block
      alignSelf={isUser ? 'flex-end' : 'flex-start'}
      maxWidth="70%"
      padding="10px 14px"
      borderRadius="14px"
      backgroundColor={isUser ? '#0070f3' : '#fff'}
      color={isUser ? '#fff' : '#333'}
      boxShadow="0 1px 3px rgba(0,0,0,0.1)"
      marginBottom="8px"
      position="relative"
    >
      <Block fontSize="14px" props={{'data-attr-masked': 'true'} as any}>
        {displayContent}
      </Block>

      <Row justifyContent="space-between" alignItems="center" marginTop="4px" width="100%">
        <Block fontSize="10px" color={isUser ? '#e0ebff' : '#888'}>
          {isStreaming ? '' : formatDate(message.createdAt)}
        </Block>

        {isStreaming && (
          <Block width="30px" height="15px" display="flex" alignItems="center" justifyContent="space-between">
            <motion.div
              style={{
                width: '4px',
                height: '4px',
                borderRadius: '50%',
                backgroundColor: '#888',
              }}
              variants={dotVariants}
              initial="initial"
              animate="animate"
              transition={{delay: 0}}
            />
            <motion.div
              style={{
                width: '4px',
                height: '4px',
                borderRadius: '50%',
                backgroundColor: '#888',
              }}
              variants={dotVariants}
              initial="initial"
              animate="animate"
              transition={{delay: 0.2}}
            />
            <motion.div
              style={{
                width: '4px',
                height: '4px',
                borderRadius: '50%',
                backgroundColor: '#888',
              }}
              variants={dotVariants}
              initial="initial"
              animate="animate"
              transition={{delay: 0.4}}
            />
          </Block>
        )}
      </Row>
    </Block>
  )
}

export default MessageBubble
